// extracted by mini-css-extract-plugin
export default {"mask":"DmTFySBc","closableMask":"U9aWa2UV","wrapper":"otjU9eWS","modalCloseBtn":"SbkEYCKv"};